import { Typography } from '@euler/app/components/typography';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { StatusPalettes } from '../constants';
import { StatusPaletteKey } from '../types';

export const StatusBadgeV2 = memo(
  ({ label, palette }: { label: string; palette: StatusPaletteKey }) => {
    const { rpx } = useResponsiveContext();
    const { text, bg } = StatusPalettes[palette];
    return (
      <HStack
        css={`
          height: ${rpx(20)}px;
          border-radius: ${rpx(4)}px;
          padding: 0 ${rpx(8)}px;
          background-color: ${bg};
          align-items: center;
          margin-right: ${rpx(6)}px;
        `}
      >
        <View
          css={`
            width: ${rpx(6)}px;
            height: ${rpx(6)}px;
            border-radius: ${rpx(6)}px;
            background-color: ${text};
            margin-right: ${rpx(5)}px;
          `}
        />
        <Typography.Label
          medium
          size={rpx(11)}
          lineHeight={rpx(15)}
          color={text}
        >
          {label}
        </Typography.Label>
      </HStack>
    );
  },
);
